import { hasCapability, type User } from "../base";

export const notifications = {
  preferences: {
    read: (user: User, { personId }: { personId: string }) => {
      return user.person.id === personId;
    },
    mutate: (user: User, { personId }: { personId: string }) => {
      return user.person.id === personId;
    },
  },
  read: (user: User, { personId }: { personId: string }) => {
    return user.person.id === personId;
  },
  mutate: (user: User, { personId }: { personId: string }) => {
    return user.person.id === personId;
  },
};

export const notificationList = {
  read: (user: User) => hasCapability(user, "notificationList.read"),
};
